import React, { Component } from "react";

import { getLists } from "../helper/list_helper";
import { renderErrorMessage } from "../helper/user_helper";

import Loader from "../components/loader";

import ListUser from "../components/list/interface/list_user";
import GiveawayInvite from "../components/list/interface/giveaway/giveaway_invite";

import { Link } from "react-router-dom";

import YaystackNavBar from "../components/yaystackNavBar";

import { getUser } from "../helper/user_helper";

class Lists extends Component {
  state = {
    loaded: false,
    errors: "",
    lists: [],
    user: null,
    invite_giveaway: null
  };

  componentDidMount() {
    this.getListsAPI();
    const self = this;
    this.userCall = getUser();
    this.userCall.promise.then(answer => {
      if (answer.signedIn === true) {
        self.setState({ signedIn: true, user: answer.user });
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <YaystackNavBar />
        <div className="profilePage list center">{this.renderLists()}</div>
      </React.Fragment>
    );
  }

  renderLists() {
    if (this.state.loaded === false) {
      return <Loader loaded={this.state.loaded} />;
    }
    if (this.state.errors !== "") {
      return <div>{renderErrorMessage(this.state.errors)}</div>;
    }
    const self = this;

    var lists = this.state.lists.map(function(list) {
      return (
        <Link
          style={{ cursor: "pointer" }}
          to={"/list/" + list.name}
          key={list.id + list.name}
        >
          <ListUser
            link={false}
            user={self.state.user}
            list={list}
            questionNumber={list.question_number}
            history={self.props.history}
            reloadlist={self.reloadlist}
            feed={true}
          />
        </Link>
      );
    });

    return (
      <div className="max_width_500">
        <div className="list_user " style={{ backgroundColor: "white" }}>
          <div>
            <label
              className="number_questions"
              style={{
                display: "block",
                marginBottom: "0px",
                color: "#9B9B9B"
              }}
            >
              We exist to
            </label>
            <label
              className="name"
              style={{
                paddingBottom: "5px",
                lineHeight: "30px",
                color: "#ff5116"
              }}
            >
              Elevate Remarkable Brands
            </label>
          </div>
        </div>
        {this.renderInviteGiveAway()}
        {lists}
      </div>
    );
  }

  renderInviteGiveAway() {
    //if (!this.state.user) return;
    if (this.state.invite_giveaway) {
      return (
        <GiveawayInvite
          invite_giveaway={this.state.invite_giveaway}
          user={this.state.user}
          history={this.props.history}
        />
      );
    }
  }

  getListsAPI = e => {
    const self = this;
    self.setState({ loaded: false, errors: "", list: null });
    this.getListCall = getLists();
    this.getListCall.promise
      .then(answer => {
        self.setState({
          loaded: true,
          lists: answer.lists,
          invite_giveaway: answer.invite_giveaway
        });
      })
      .catch(error => {
        self.setState({ loaded: true, errors: error.errors });
      });
  };

  reloadlist = list => {};
}

export default Lists;



// WEBPACK FOOTER //
// ./src/pages/lists.jsx